import React, { FC, ChangeEvent, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  ActionsGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FlatButton,
  Input,
  TitleText,
  WaitingButton,
} from "@evergis/ui";

import { useBookmarks } from "modules/MapControls/hooks/useBookmarks";
import { useDialogReset } from "../../../hooks/useDialogs";

export const AddBookmark: FC = () => {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const closeAddBookmarkDialog = useDialogReset();
  const { addBookmark, loading } = useBookmarks();

  const createBookmark = useCallback(() => {
    addBookmark({ title });
    closeAddBookmarkDialog();
  }, [addBookmark, closeAddBookmarkDialog, title]);

  const changeTitle = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) => {
      setTitle(target.value);
    },
    [setTitle],
  );

  return (
    <Dialog onClick={e => e.preventDefault()} isOpen maxWidth="34.5rem" onCloseRequest={closeAddBookmarkDialog}>
      <DialogTitle>
        <TitleText>{t("addBookmark.dialogHeader", { ns: "dialogs" })}</TitleText>
      </DialogTitle>
      <DialogContent>
        <Input
          width="27.5rem"
          label={t("addBookmark.bookmarkName", { ns: "dialogs" })}
          placeholder={t("addBookmark.bookmarkNamePlaceholder", { ns: "dialogs" })}
          value={title}
          onChange={changeTitle}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <ActionsGroup>
          <WaitingButton primary onClick={createBookmark} disabled={!title || loading} isWaiting={loading}>
            {t("actions.save", { ns: "common" })}
          </WaitingButton>
          <FlatButton onClick={closeAddBookmarkDialog}>{t("actions.cancel", { ns: "common" })}</FlatButton>
        </ActionsGroup>
      </DialogActions>
    </Dialog>
  );
};
